import { GenericAnalyticsEvent } from './types';

const trackEvent = async (data: GenericAnalyticsEvent) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

const trackStartSearch = (payload: any) => {
  trackEvent({
    event: 'analytics_event',
    name: 'start_search',
    properties: payload,
  });
};

export { trackEvent, trackStartSearch };
